import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyEucalyptusIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./EucalyptusIcon-2f84093d.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyEucalyptusIcon as P };
